import { css, html } from 'react-strict-dom';

import { Style } from '../../constants';
import { color } from '../../constants/color.css';
import PageWrapPadding from '../PageWrapPadding';
import Skeleton from '../Skeleton';
import Stack from '../Stack';

const TIMELINE_ITEMS = [0, 1, 2];
const SIDEBAR_CARDS = [0, 1, 2];

/** Skeleton for the ticket detail screen (`TicketPage`). */
export default function TicketDetailSkeleton() {
  return (
    <PageWrapPadding top horizontal bottom>
      <Stack gap={0.5}>
        <Stack style={Style.alignStart}>
          <Skeleton width={150} height={16} />
        </Stack>

        <html.div
          style={[Style.row, Style.alignCenter, Style.wrap, styles.titleRow]}
        >
          <Skeleton width={90} height={22} radius={100} />
          <Skeleton width={110} height={16} />
          <Skeleton width={320} height={28} />
        </html.div>

        <html.div style={[Style.row, Style.alignCenter, styles.metaRow]}>
          <Skeleton width={140} height={12} />
          <Skeleton width={40} height={12} />
        </html.div>
      </Stack>

      <html.div style={styles.mobileTabBar}>
        <Skeleton width="100%" height={36} radius={8} />
      </html.div>

      <Stack style={[Style.row, styles.columns]} gap={1.5}>
        <Stack gap={1.5} style={[Style.fill, styles.timelineColumn]}>
          {TIMELINE_ITEMS.map((index) => (
            <Stack
              key={index}
              padH={1.5}
              padV={1.5}
              gap={1}
              style={styles.commentCard}
            >
              <html.div
                style={[Style.row, Style.alignCenter, styles.commentHeader]}
              >
                <Skeleton width={32} height={32} circle />
                <Skeleton width={140} height={12} />
              </html.div>
              <Skeleton width="100%" height={12} />
              <Skeleton width="85%" height={12} />
            </Stack>
          ))}

          <html.div style={styles.composer}>
            <Skeleton width="100%" height={56} radius={8} />
          </html.div>
        </Stack>

        <Stack gap={1.5} style={styles.sidebar}>
          {SIDEBAR_CARDS.map((index) => (
            <html.div key={index} style={styles.sidebarCard}>
              <Skeleton width={100} height={12} />
              <Skeleton width="100%" height={12} />
              <Skeleton width="70%" height={12} />
            </html.div>
          ))}
        </Stack>
      </Stack>
    </PageWrapPadding>
  );
}

const styles = css.create({
  titleRow: {
    gap: 8,
  },
  metaRow: {
    gap: 12,
  },
  mobileTabBar: {
    display: {
      default: 'block',
      '@media (min-width: 1200px)': 'none',
    },
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: color.neutral20,
    marginTop: 16,
    marginBottom: 16,
  },
  columns: {
    flexDirection: {
      default: 'row',
      '@media (max-width: 1199px)': 'column',
    },
  },
  timelineColumn: {
    minWidth: 0,
  },
  commentCard: {
    backgroundColor: color.neutral0,
    borderRadius: 12,
    boxShadow: '0px 16px 16px 0px rgba(0, 0, 0, 0.04)',
  },
  commentHeader: {
    gap: 8,
  },
  composer: {
    marginTop: 8,
  },
  sidebar: {
    width: {
      default: 350,
      '@media (max-width: 1199px)': '100%',
    },
  },
  sidebarCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    backgroundColor: color.neutral0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.neutral20,
    borderRadius: 12,
    paddingBlock: 16,
    paddingInline: 16,
  },
});
